import { render, staticRenderFns } from "./thank-you.vue?vue&type=template&id=fabd125a&scoped=true"
import script from "./thank-you.vue?vue&type=script&lang=js"
export * from "./thank-you.vue?vue&type=script&lang=js"
import style0 from "./thank-you.vue?vue&type=style&index=0&id=fabd125a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabd125a",
  null
  
)

export default component.exports